import { createFileRoute } from '@tanstack/react-router';
import { AgencyCampaignsPage } from '../features/agency/AgencyCampaignsPage/AgencyCampaignsPage';
import { AgencyCampaignSection } from '../features/agency/model';
import { campaignsRouteSearchSchema } from '../features/campaigns/campaigns/campaignsRouteSearch';
export const Route = createFileRoute('/a/$agencyId_/campaigns/brands/$brandId/details')({
  validateSearch: campaignsRouteSearchSchema,
  component: DetailsRoute,
});
function DetailsRoute() {
  const { brandId } = Route.useParams();
  return <AgencyCampaignsPage section={AgencyCampaignSection.Brands} brandId={brandId} />;
}
